import { IMediaBuilderProps } from "../../Utility/MediaBuilder/MediaBuilder";
import { TCardType } from "./CreditCardInfo/CreditCardInfo.interface";

/** Returns a particular svg asset regarding the type of the credit card */
const getCreditCardAsset = (cardType: TCardType): IMediaBuilderProps | null => {
  switch (cardType) {
    case "mastercard":
      return { type: "svg-icon", data: { icon: "MastercardIcon" } };
    case "visa":
      return { type: "svg-icon", data: { icon: "VisaIcon" } };
    default:
      return null;
  }
};

export default getCreditCardAsset;
